Ext.define('SA.EditScatterPlotGeographicUnitRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        var {commaList, htmlEncode} = Ext.util.Format,
            datasets = this.model.getDatasetsWithNoMatchingUnitsForLocation(),
            nameEls = datasets.map(SA.data.Datasets.getName).map(htmlEncode).map(name => `<strong>‘${name}’</strong>`);

        return `The data variables in the ${commaList(nameEls, 'and', 'dataset')} do not match any available geographic units of this scatter plot.`;
    },

    isBroken() {
        return !this.model.canResolveGeographicUnit();
    }
});
